import { SelectedTier } from '@aptitude/shared';
import { Identifier } from '@aptitude/shared';
import { ConversionsCount } from './commitment-mix-model';

export class MixPartnerLevelGraphQL {
  rfpId!: number;
  name!: string;
  id!: number;
  status!: string;
  mixType!: string;
  optimizedOfferOrSelectionId!: number;
  result!: Result;
  offers!: OfferElement[];
  purchasePlanningLevel?: string;
  auditInfo?: {
    lastModifiedBy: string,
    lastModifiedDate: string
  };
  statusChangedBy!: string;
  statusChangedDate!: string;
  constructor(data: unknown) {
    Object.assign(this, data);
  }
}

export interface OfferElement {
  planSelectionId?: number;
  contracted: boolean;
  offer: OfferOffer;
  selectedTier?: SelectedTier;
  contract?: PPContract | null;
  result: {
    plannedSpend?: EdSpend;
    complianceSpend?: EdSpend;
    conversionsCount: ConversionsCount;
    allocatedMarketShare?: number;
  };
  tiers?: Array<SelectedTier>,
  seller: Identifier;
  name: string;
  pricingTier?: any;
  selected?: boolean;
}

export interface OfferOffer {
  id?: any;
  name: any;
  status?: string;
  sellerId: any;
  seller: Identifier;
  contract: PPContract;
  tiers?: Array<SelectedTier>,
  supportedOfferTerm?: {
    commitmentType: string;
  }
}

export interface Result {
  id: number;
  continuedSpend: EdSpend;
  plannedSpend: EdSpend;
  excludedPlannedSpend: EdSpend;
  incumbentPlannedSpend: EdSpend;
  conversionsCount: any;
}

export interface EdSpend {
  spendMarketShare?: number;
  unitMarketShare?: number;
  spendVolume: number;
  spendVolumeBracket: number;
  unitVolume: number;
  productCount: number;
}

export interface PPContract {
  effectiveDate: Date;
}

export interface MixPurchasePlan {
  id: number;
}

export enum SPEND_LEVEL_TYPES {
  DOLLAR_MARKET_SHARE = 'DOLLAR_MARKET_SHARE',
  UNIT_MARKET_SHARE = 'UNIT_MARKET_SHARE',
  ABSOLUTE_DOLLARS = 'ABSOLUTE_DOLLARS',
  ABSOLUTE_UNITS = 'ABSOLUTE_UNITS'
}

